import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import { Toast } from 'vant';
import { wechatShare } from '@/common/wechatShare'
import '@/assets/css/reset.css'

Vue.config.productionTip = false;

Vue.prototype.$share = wechatShare
Vue.use(Toast);
require('@/common/common.js')

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
